import { useQuery } from "@tanstack/react-query"

import useSlugExtractor from "@hooks/useSlugExtractor"
import useUser from "@hooks/useUser"

import appendSearchParams from "@utils/appendSearchParams"

import { CATALOG_ENDPOINTS } from "@endpoints/catalogs"

export function useCategoriesQuery(catalogId: number, brandParam: string) {
    const { user } = useUser()
    const [categoriesEndpointTemplate] = useSlugExtractor([CATALOG_ENDPOINTS.CATEGORIES])
    // The brandless bucket is addressed by the null-scope sentinel (brand=0), so one endpoint
    // serves both a real brand's tabs and the "No Brand" page's.
    const categoriesEndpoint = appendSearchParams(categoriesEndpointTemplate, {
        catalog: catalogId,
        brand: brandParam,
    })

    return useQuery({
        queryKey: ["catalog-categories", catalogId, brandParam, categoriesEndpoint],
        queryFn: async () => {
            const response = await fetch(categoriesEndpoint)

            if (!response.ok) {
                throw new Error(`Request to ${categoriesEndpoint} failed with status ${response.status}.`)
            }

            return (await response.json()) as CatalogCategory[]
        },
        enabled: !!user?.service_company?.slug,
    })
}
